import styled from "@emotion/styled";

const AsteriskWrapper = styled.span`
  color: ${(props) => props.theme.scheme.red.r100};
  margin-right: 0.25rem;
`;

export const RequiredAsterisk = () => <AsteriskWrapper>*</AsteriskWrapper>;
